import { useState } from "react";
import { Megaphone, CheckCircle2, TrendingUp, Gift, Link2 } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { TextField, TextArea } from "@/components/Modal";
import { toast } from "sonner";

export default function DevenirInfluenceur() {
  const [f, setF] = useState({ name: "", email: "", phone: "", social: "", audience: "", message: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/influencers/apply", f);
      setSent(true);
      toast.success("Candidature envoyée !");
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 py-8" data-testid="devenir-influenceur">
      <div className="rounded-2xl bg-gradient-to-br from-[#0F172A] to-[#1E293B] text-white p-6 sm:p-10 mb-8">
        <div className="inline-flex items-center gap-2 bg-[#C85A32] rounded-full px-3 py-1 text-xs font-bold mb-4"><Megaphone className="w-4 h-4" /> Programme d'affiliation</div>
        <h1 className="font-display text-3xl sm:text-4xl font-black leading-tight">Gagnez de l'argent en recommandant TOGOBATI</h1>
        <p className="text-slate-300 mt-3 max-w-2xl">Partagez votre lien unique, faites découvrir nos matériaux et services d'installation, et touchez une commission sur chaque commande livrée de vos filleuls.</p>
      </div>

      <div className="grid sm:grid-cols-3 gap-4 mb-10">
        {[[Link2, "Lien & QR uniques", "Recevez un code, un lien de suivi et un QR code personnalisés."],
          [TrendingUp, "Commissions automatiques", "Vos gains sont calculés dès qu'une commande de vos filleuls est livrée."],
          [Gift, "Retraits faciles", "Demandez un retrait par Mobile Money ou virement dès le seuil atteint."]].map(([Icon, t, d]) => (
          <div key={t} className="bg-white border border-slate-200 rounded-xl p-5">
            <div className="w-10 h-10 rounded-lg bg-[#FDF3EE] flex items-center justify-center mb-3"><Icon className="w-5 h-5 text-[#C85A32]" /></div>
            <p className="font-bold text-slate-800">{t}</p>
            <p className="text-sm text-slate-500 mt-1">{d}</p>
          </div>
        ))}
      </div>

      {sent ? (
        <div className="bg-white border border-green-200 rounded-2xl p-8 text-center max-w-lg mx-auto" data-testid="apply-success">
          <CheckCircle2 className="w-14 h-14 text-green-500 mx-auto mb-3" />
          <h2 className="font-display text-2xl font-bold text-slate-800">Candidature reçue !</h2>
          <p className="text-slate-500 mt-2">Notre équipe examine votre demande. Vous recevrez un email avec votre code de parrainage et vos accès dès validation.</p>
        </div>
      ) : (
        <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 max-w-lg mx-auto">
          <h2 className="font-display text-2xl font-bold text-slate-800 mb-4">Postuler au programme</h2>
          <form onSubmit={submit} className="space-y-3">
            <TextField label="Nom complet" value={f.name} onChange={set("name")} required testid="apply-name" />
            <TextField label="Email" type="email" value={f.email} onChange={set("email")} required testid="apply-email" />
            <TextField label="Téléphone" value={f.phone} onChange={set("phone")} testid="apply-phone" />
            <TextField label="Réseaux sociaux (lien/pseudo)" value={f.social} onChange={set("social")} testid="apply-social" />
            <TextField label="Taille de votre audience" value={f.audience} onChange={set("audience")} placeholder="ex. 5 000 abonnés Instagram" testid="apply-audience" />
            <TextArea label="Message (facultatif)" value={f.message} onChange={set("message")} testid="apply-message" />
            <button disabled={busy} className="w-full bg-[#C85A32] text-white font-bold py-3 rounded-lg hover:bg-[#A94520] transition disabled:opacity-50" data-testid="apply-submit">{busy ? "Envoi…" : "Envoyer ma candidature"}</button>
          </form>
        </div>
      )}
    </div>
  );
}
